var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    width: 30.816,
    height: 32.783,
    viewBox: "0 0 30.816 32.783",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#414141}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    d: "M5.845 10.491A5.178 5.178 0 0 1 .6 5.245 5.282 5.282 0 0 1 5.845 0a5.393 5.393 0 0 1 5.245 5.245 5.282 5.282 0 0 1-5.245 5.246zm0-8.851a3.638 3.638 0 0 0-3.606 3.605 3.638 3.638 0 0 0 3.606 3.606 3.638 3.638 0 0 0 3.606-3.606 3.638 3.638 0 0 0-3.606-3.606z",
    className: "cls-1",
    "data-name": "Path 89",
    transform: "translate(-.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    d: "M18.534 12.468A3.989 3.989 0 0 1 14.6 8.534a3.934 3.934 0 1 1 7.868 0 3.989 3.989 0 0 1-3.934 3.934zm0-6.393a2.241 2.241 0 0 0-2.295 2.295 2.295 2.295 0 1 0 4.59 0 2.241 2.241 0 0 0-2.295-2.295z",
    className: "cls-1",
    "data-name": "Path 90",
    transform: "translate(8.348 2.94)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    d: "M13.084 25.369a6.884 6.884 0 1 1 6.884-6.884 6.821 6.821 0 0 1-6.884 6.884zm0-12.294a5.282 5.282 0 0 0-5.245 5.245 5.541 5.541 0 0 0 5.245 5.409 5.282 5.282 0 0 0 5.245-5.245 5.424 5.424 0 0 0-5.245-5.409z",
    className: "cls-1",
    "data-name": "Path 91",
    transform: "translate(2.979 7.414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    d: "M10.026 20.005c-.164 0-.328 0-.328-.164C1.666 15.579 3.142 6.236 3.142 6.072a.722.722 0 0 1 .983-.656.8.8 0 0 1 .492.983c0 .328-1.311 8.36 5.737 11.966a.94.94 0 0 1 .328 1.147c-.164.329-.328.493-.656.493z",
    className: "cls-1",
    "data-name": "Path 92",
    transform: "translate(.956 3.435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    d: "M13.736 17.579a1.089 1.089 0 0 1-.82-.656.722.722 0 0 1 .656-.983 6.9 6.9 0 0 0 5.246-6.72.82.82 0 1 1 1.639 0c0 6.721-6.393 8.2-6.557 8.36z",
    className: "cls-1",
    "data-name": "Path 93",
    transform: "translate(7.245 5.369)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoles);
export default __webpack_public_path__ + "static/media/roles.eb8626279ae073490db5ea02cc993e9c.svg";
export { ForwardRef as ReactComponent };